import { Builder } from "@builder.io/react";

import { BuilderRetailerBrandTileSection } from "./BuilderRetailerBrandTileSection";

export const registerBuilderRetailerBrandTileSection = () => {
  Builder.registerComponent(BuilderRetailerBrandTileSection, {
    name: "RetailerBrandTileSection",
    hideFromInsertMenu: false,
    noWrap: true,
    canHaveChildren: false,
    inputs: [
      {
        name: "brands",
        type: "list",
        helperText: "Duplicate brands will be automatically removed.",
        subFields: [
          {
            name: "token",
            type: "string",
          },
          {
            name: "brandTileType",
            type: "enum",
            defaultValue: "common",
            enum: ["common", "carousel", "marketList"],
            required: true,
          },
          {
            name: "withoutFavourite",
            type: "boolean",
            defaultValue: false,
            required: false,
          },
          {
            name: "showMinimum",
            friendlyName: "Show Brand Minimum",
            type: "boolean",
            defaultValue: false,
            required: false,
          },
        ],
        required: true,
      },
      {
        name: "columns",
        friendlyName: "Number of Columns",
        type: "object",
        subFields: [
          {
            name: "mobileAndAbove",
            type: "number",
            defaultValue: 2,
          },
          {
            name: "tabletAndAbove",
            type: "number",
            defaultValue: 2,
          },
          {
            name: "desktopAndAbove",
            type: "number",
            defaultValue: 2,
          },
          {
            name: "xLargeAndAbove",
            type: "number",
            defaultValue: 2,
          },
          {
            name: "xxLargeDesktop",
            type: "number",
            defaultValue: 2,
          },
        ],
      },
      {
        name: "rowGap",
        friendlyName: "Row Gap (px)",
        type: "object",
        subFields: [
          {
            name: "mobileAndAbove",
            type: "number",
            defaultValue: 8,
          },
          {
            name: "tabletAndAbove",
            type: "number",
            defaultValue: 8,
          },
          {
            name: "desktopAndAbove",
            type: "number",
            defaultValue: 8,
          },
          {
            name: "xLargeAndAbove",
            type: "number",
            defaultValue: 8,
          },
          {
            name: "xxLargeDesktop",
            type: "number",
            defaultValue: 8,
          },
        ],
      },
      {
        name: "columnGap",
        friendlyName: "Column Gap (px)",
        type: "object",
        subFields: [
          {
            name: "mobileAndAbove",
            type: "number",
            defaultValue: 8,
          },
          {
            name: "tabletAndAbove",
            type: "number",
            defaultValue: 8,
          },
          {
            name: "desktopAndAbove",
            type: "number",
            defaultValue: 8,
          },
          {
            name: "xLargeAndAbove",
            type: "number",
            defaultValue: 8,
          },
          {
            name: "xxLargeDesktop",
            type: "number",
            defaultValue: 8,
          },
        ],
      },
    ],
  });
};
